// extracted by mini-css-extract-plugin
export default {"preview":"QuotaPolicies_preview__OW7YW"};